module.exports = __webpack_public_path__ + "img/SL-M-200-260.e9a5866d.svg";